export default "/_next/static/images/dog3-ecf636240e07aa15954cb45ee9d898c2.png";